<section class="features-section">

  <!-- Right decorative mark — placed in the side gutter -->
  <img src="images/webps/bee.png" class="deco-tr" alt="" aria-hidden="true" />

  <div class="features-container">

    <!-- V logo sits inside the container, above the Fair Pricing card -->
    <img src="images/webps/v.png" class="deco-tl" alt="" aria-hidden="true" />

    <h2 class="features-heading">ERP Designed For <span>Modern Teams</span></h2>

    <div class="features-grid">

      <!-- Card 1: Fair Pricing -->
      <article class="feat-card">
        <h3>Fair pricing</h3>
        <p>No usage-based pricing, no feature upselling, no long term contracts, no hosting limits, no surprises... just a single price per user - all inclusive.</p>
        <button type="button" (click)="goToPricing()">View pricing</button>
      </article>

      <!-- Card 2: 80+ Apps -->
      <article class="feat-card">
        <h3>80+ Apps</h3>
        <p>Powered by its connected ERP<br>ecosystem, OrderYaa delivers<br>smart business applications<br>for every business operation.</p>
        <button type="button" (click)="goToApps()">Discover Solutions</button>
      </article>

      <!-- Card 3: Smart POS -->
      <article class="feat-card">
        <h3>Smart POS + Seamless Operations = <span class="heart">&#10084;</span></h3>
        <p><span class="pos-brand" (click)="openPosApp()">orderYaa POS</span> helps you manage retail operations, inventory, and sales — all from one connected platform.</p>
        <div class="pos-img-wrap">
          <img src="images/webps/pos-screen.png" alt="OrderYaa POS preview" />
        </div>
      </article>

      <!-- Card 4: Less Complexity -->
      <article class="feat-card">
        <h3>Less Complexity</h3>
        <p>OrderYaa ERP gives businesses<br>complete control, seamless<br>automation, and the flexibility<br>modern teams actually need.</p>
      </article>

    </div>

  </div>

  <img src="images/webps/lines.png" class="deco-strokes" alt="" aria-hidden="true" />

</section>